import settings from '../utils/settings';

export const ENPHASE_URL = 'https://enphase.com';
export const PLATFORM_VIDEO_LINK = 'https://enphaseenergy.wistia.com/medias/c09j6kms57';
export const DIGITAL_PLATFORM_LINK = 'https://enphaseenergy.wistia.com/medias/c09j6kms57';
export const SOLARGRAF_REGISTER_LINK = 'https://www.solargraf.com/register/';
export const SOLARGRAF_DRAW_DESIGN_TUTORIAL =
  'https://www.youtube.com/embed/mJZF2LROdZs?rel=0&playlist=mJZF2LROdZs&loop=1';
export const RELEASE_NOTES_URL = 'https://support.enphase.com/s/topic/0TO3m000001DxBvGAK/enphase-installer-portal-release-notes?tabset-b0285=2';

export const FEATURES = {
  EIN_DASHBOARD: 'EIN_DASHBOARD',
  EIN_ADMIN: 'EIN_ADMIN',
  PERMIT_ENABLED: 'PERMIT_ENABLED',
  BOM_CALCULATOR: 'BOM_Calculator',
  LEAD_OPT_IN: '21noveinprofile2019',
  EIN_OPT_IN: 'EIN_OPT_IN',
  LRE_ENABLED: 'LRE_ENABLED',
  INCENTIVE_PROGRAM: 'INCENTIVE_PROGRAM',
  EIN_MERCHANDISE: 'EIN_MERCHANDISE',
  PERMIT_ADMIN: 'PERMIT_ADMIN',
  SGIP_ADMIN: 'SGIP_ADMIN',
  SOLARGRAF_ENABLED: 'SOLARGRAF_ENABLED',
  SOLARGRAF_PLATFORM_INSTALLER: 'Solargraf_Platform_Installer',
  DRS_ENABLED_COMPANY: 'DRS_ENABLED_COMPANY',
  DRS_ENABLED_USER: 'DRS_ENABLED_USER',
  DRS_AUSTRALIA_LAUNCH: 'DRS_AUSTRALIA_LAUNCH',
  DRS_SOUTH_AFRICA_LAUNCH: 'DRS_SOUTH_AFRICA_LAUNCH',
  DRS_NEW_ZEALAND_LAUNCH: 'DRS_NEW_ZEALAND_LAUNCH',
  DRS_GERMANY_LAUNCH: 'DRS_GERMANY_LAUNCH',
  DRS_BELGIUM_LAUNCH: 'DRS_BELGIUM_LAUNCH',
  DRS_MEXICO_LAUNCH: 'DRS_MEXICO_LAUNCH',
  DRS_AUSTRIA_LAUNCH: 'DRS_AUSTRIA_LAUNCH',
  DRS_CANADA_LAUNCH: 'DRS_CANADA_LAUNCH',
  DRS_FRANCE_LAUNCH: 'DRS_FRANCE_LAUNCH',
  DRS_NETHERLANDS_LAUNCH: 'DRS_NETHERLANDS_LAUNCH',
  DRS_SWITZERLAND_LAUNCH: 'DRS_SWITZERLAND_LAUNCH',
  DRS_SPAIN_LAUNCH: 'DRS_SPAIN_LAUNCH',
  DRS_PORTUGAL_LAUNCH: 'DRS_PORTUGAL_LAUNCH',
  DRS_DENMARK_LAUNCH: 'DRS_DENMARK_LAUNCH',
  DRS_SWEDEN_LAUNCH: 'DRS_SWEDEN_LAUNCH',
  DRS_GREECE_LAUNCH: 'DRS_GREECE_LAUNCH',
  ACTIVATION_WEB_FEATURE: 'activation_web_feature',
  LEAD_PURCHASE_STORE: 'Lead_Purchase_Store',
  COMMERCIAL_SHORTCUT_PAGE: 'Commercial_Shortcut_Page',
  TRAINING_DASHBOARD_FEATURE: 'training_dashboard',
  PORTUGUESE_TRANSLATION: 'pt_translations',
  POLISH_TRANSLATION: 'pl_translations',
  FLEET_DASHBOARD: 'enable_fleet_dashboard_by_company',
  AUTHORIZED_SUBCONTRACTOR: 'authorized_subcontractor',
  GENERATOR_TOKENS: 'generator_tokens',
  RMA_DASHBOARD: 'rma_dashboard',
  GRID_PROFILE_SELF_INSTALLER_FEATURE_ID: 'grid_profile_self_installer',
  CELLMODEM_DATA_PLAN_EXTENSION: 'CellModem_Data_Plan_Extension',
  EVSE_INCENTIVES_TOOL: 'evse_incentives_tool'
};

const US = {
  support: 'https://enphase.com/en-us/support/contact-support',
  enlightenHelp: 'https://enphase.com/en-us/support/solar-professionals/software?modal-content=support-regions&m=mgr',
  enphaseStore: window.build_environment === 'qa2'
    ? 'https://store-qa2.enphase.com/storefront/en-us/'
    : 'https://store.enphase.com/storefront/en-us/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/en-us/legal/privacy-policy',
  terms: 'https://enphase.com/en-us/legal/terms-of-service',
};

const AU = {
  support: 'https://enphase.com/en-au/support/contact',
  enlightenHelp: 'https://enphase.com/en-au/support/solar-professionals/software',
  enphaseStore: window.build_environment === 'qa2'
    ? 'https://store-qa2.enphase.com/storefront/en-au/'
    : 'https://store.enphase.com/storefront/en-au/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/en-au/legal/privacy-policy',
  terms: 'https://enphase.com/en-au/legal/terms-of-service',
  productWarrantyExtension: 'https://encare.enphase.com/?upgradeProgramType=4',
};

const DE = {
  support: 'https://enphase.com/de-de/support/kontaktieren',
  enlightenHelp: 'https://enphase.com/de-de/support/solarprofis/enlighten-manager?m=mgr',
  enphaseStore: window.build_environment === 'qa2'
    ? 'https://store-qa2.enphase.com/storefront/de-de/'
    : 'https://store.enphase.com/storefront/de-de/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/de-de/datenschutzrichtlinie',
  terms: 'https://enphase.com/de-de/legal/service-und-nutzungsbestimmungen',
};

const NL = {
  support: 'https://enphase.com/nl-nl/support/contact',
  enlightenHelp: 'https://enphase.com/nl-nl/support/zonne-energieprofessionals/enlighten-manager?m=mgr',
  enphaseStore: window.build_environment === 'qa2'
    ? 'https://store-qa2.enphase.com/storefront/nl-nl/'
    : 'https://store.enphase.com/storefront/nl-nl/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/nl-nl/legal/privacybeleid',
  terms: 'https://enphase.com/nl-nl/legal/algemene-voorwaarden'
};

const NC = {
  support: 'https://enphase.com/en-au/support/contact',
  enlightenHelp: 'https://enphase.com/en-au/support/solar-professionals/software',
  enphaseStore: window.build_environment === 'qa2'
    ? 'https://store-qa2.enphase.com/storefront/en-au/'
    : 'https://store.enphase.com/storefront/en-au/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/en-us/legal/privacy-policy',
  terms: 'https://enphase.com/en-us/legal/terms-of-service',
  productWarrantyExtension: 'https://encare.enphase.com/?upgradeProgramType=4',
};
const NZ = {
  support: 'https://enphase.com/en-au/support/contact',
  enlightenHelp: 'https://enphase.com/en-au/support/solar-professionals/software',
  enphaseStore: window.build_environment === 'qa2'
    ? 'https://store-qa2.enphase.com/storefront/en-au/'
    : 'https://store.enphase.com/storefront/en-au/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/en-us/legal/privacy-policy',
  terms: 'https://enphase.com/en-us/legal/terms-of-service',
  productWarrantyExtension: 'https://encare.enphase.com/?upgradeProgramType=4&locale=en-nz',
};
const BE = {
  support: 'https://enphase.com/nl-nl/support/contact',
  enlightenHelp: 'https://enphase.com/nl-nl/support/zonne-energieprofessionals/enlighten-manager?m=mgr',
  enphaseStore: window.build_environment === 'qa2'
    ? 'https://store-qa2.enphase.com/storefront/nl-be/'
    : 'https://store.enphase.com/storefront/nl-be/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/nl-nl/legal/privacybeleid',
  terms: 'https://enphase.com/nl-nl/legal/algemene-voorwaarden',
};

const IN = {
  support: 'https://enphase.com/en-in/support/contact-support',
  enlightenHelp: 'https://enphase.com/en-us/support/solar-professionals/software?modal-content=support-regions&m=mgr',
  privacy: 'https://enphase.com/en-us/legal/privacy-policy',
  terms: 'https://enphase.com/en-us/legal/terms-of-service',
  productWarrantyExtension: 'https://encare.enphase.com/?upgradeProgramType=4&locale=en-in',
};

const MX = {
  support: 'https://enphase.com/es-lac/contact-support-es-lac',
  enlightenHelp: 'https://enphase.com/es-lac/soporte/profesionales/enlighten-manager?m=mgr',
  privacy: 'https://enphase.com/es-lac/condiciones-legales/politica-de-privacidad',
  terms: 'https://enphase.com/es-lac/condiciones-legales/terminos-y-condiciones',
  productWarrantyExtension: 'https://encare.enphase.com/?upgradeProgramType=4',
};

const IT = {
  support: 'https://enphase.com/it-it/support/contact',
  enlightenHelp: 'https://www2.enphase.com/enlighten-help/it/?m=mgr',
  privacy: 'https://enphase.com/it-it/note-legali/informativa-sulla-privacy',
  terms: 'https://enphase.com/it-it/note-legali/condizioni-del-servizio'
};

const FR = {
  support: 'https://enphase.com/fr-fr/nous-contacter',
  enlightenHelp: 'https://enphase.com/fr-fr/support/professionnels/enlighten-manager?m=mgr',
  enphaseStore: window.build_environment === 'qa2'
    ? 'https://store-qa2.enphase.com/storefront/fr-fr/'
    : 'https://store.enphase.com/storefront/fr-fr/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/fr-fr/juridique/politique-de-confidentialite',
  terms: 'https://enphase.com/fr-fr/juridique/conditions-generales'
};
const CH = {
  support: 'https://enphase.com/fr-fr/nous-contacter',
  enlightenHelp: 'https://enphase.com/fr-fr/support/professionnels/enlighten-manager?m=mgr',
  enphaseStore: window.build_environment === 'qa2'
    ? 'https://store-qa2.enphase.com/storefront/fr-fr/'
    : 'https://store.enphase.com/storefront/fr-fr/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/fr-fr/juridique/politique-de-confidentialite',
  terms: 'https://enphase.com/fr-fr/juridique/conditions-generales'
};
const ES = {
  support: 'https://enphase.com/es-es/empresa/contacto',
  enlightenHelp: 'https://enphase.com/es-es/soporte/profesionales/software',
  messageFromCeo: 'https://cdn2.hubspot.net/hubfs/2448117/CEO%20Letter%20to%20Partners.pdf',
  enphaseStore: window.build_environment === 'qa2'
    ? 'https://store-qa2.enphase.com/storefront/es-es/'
    : 'https://store.enphase.com/storefront/es-es/?utm_source=enlighten-manager-home&utm_medium=referral',
  privacy: 'https://enphase.com/es-es/condiciones-legales/politica-de-privacidad',
  terms: 'https://enphase.com/es-es/condiciones-legales/terminos-y-condiciones',
};

export default { US, AU, DE, NL, BE, IN, MX, NZ, NC, IT, FR, ES, CH};
